import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import useUnitContext from '/@/core/context/unit';
import settings from '/@/core/settings';
import { useNitrogenSources } from '/@/hooks/nitrogen-smart';
import { _ } from '/@/locale';
import {
    setBtnDisabled,
    setFertilizer as setFertilizerAction,
    setFertilizerAmount as setFertilizerAmountAction,
} from '/@/store/crop-monitoring/actions';
import { getFertilizer, getFertilizerAmount } from '/@/store/crop-monitoring/selectors';
import Input from '/@/v3/components/forms/input';
import Select from '/@/v3/components/forms/select';
import Title from '/@/v3/components/title';

function StepChooseFertilizer({ handleNext }: { handleNext: () => void }) {
    const dispatch = useDispatch();
    const units = useUnitContext();

    const { data: nitrogenSources } = useNitrogenSources();
    const fertilizer = useSelector(getFertilizer);
    const setFertilizer = bindActionCreators(setFertilizerAction, dispatch);

    const fertilizerAmount = useSelector(getFertilizerAmount);
    const setFertilizerAmount = bindActionCreators(setFertilizerAmountAction, dispatch);

    const validation = (Boolean(fertilizerAmount) && Boolean(fertilizer)) || (!fertilizerAmount && !fertilizer);

    useEffect(() => {
        dispatch(setBtnDisabled(!validation));
    }, [fertilizerAmount, fertilizer]);

    const validate = (e) => {
        if (validation && e.keyCode === 13) {
            handleNext();
        }
    };

    return (
        <Grid container spacing={2} sx={{ mt: 2, mb: 4 }}>
            <Grid item container md={6} flexDirection='column' spacing={2}>
                <Grid item>
                    <Title bolder size='sm'>
                        {_('Tipo')}
                    </Title>
                </Grid>
                <Grid item>
                    <Select
                        color={settings.app.theme}
                        options={nitrogenSources || []}
                        placeholder={_('Tipo de fertilizante')}
                        value={fertilizer}
                        onChange={setFertilizer}
                        maxHeight='200px'
                        clearable
                    />
                </Grid>
            </Grid>
            <Grid item container md={6} flexDirection='column' spacing={2}>
                <Grid item>
                    <Title bolder size='sm'>
                        {_('Cantidad')}
                    </Title>
                </Grid>
                <Grid item>
                    <Input
                        type=''
                        color={settings.app.theme}
                        placeholder={_('Ingrese la cantidad')}
                        value={fertilizerAmount || ''}
                        onChange={(v) => setFertilizerAmount(v)}
                        suffix={'kg/ha'}
                        onKeyDown={(e) => validate(e)}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default StepChooseFertilizer;
